import script from "./FilterWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterWidget.vue?vue&type=script&setup=true&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"

const __exports__ = script;

export default __exports__